import React from "react";
import NullableValue from "../../../../Utils/renderField/nullableValue";

// Bloque del reporte: título, el cierre del que se tomaron los datos y su tabla
export const ExistenciaSeccion = ({
    titulo,
    datos = [],
    sinDatos,
    mensajeVacio,
    children,
}) => {
    return (
        <div className="mb-4">
            <label className="formulario-field__label reporte-inventario__resumen-header-lbl">
                {titulo}
            </label>

            {datos.length > 0 && (
                <div className="reporte-inventario__resumen mb-3">
                    <div className="formulario-fields-row my-0">
                        {datos.map((dato) => (
                            <div className="formulario-field" key={dato.label}>
                                <label className="formulario-field__label">
                                    {dato.label}
                                </label>
                                <div className="formulario-field__value">
                                    <NullableValue value={dato.valor} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {sinDatos ? (
                <div className="text-center py-5">
                    <h3>{mensajeVacio}</h3>
                </div>
            ) : (
                children
            )}
        </div>
    );
};
